export default "__VITE_ASSET__a5487c0b__"